/* eslint-disable max-len */
import React, { useRef, useState,useEffect } from "react";
import { useOnClickOutside } from "../../../../../CommonMethods/OutsideClick";
import moment from "moment";
const DropDownComponent = ({
    placeHolder,
    id,
    divClassName,
    options,
    handleOnchangeInput,
    value,
    dropDownName,
    index,
    buttonDisabled,
    buttonClassName,
    tooltip,
    title,
    test_id,
    isDisplay
}) => {
    const [isOpen, setisOpen] = useState(false);
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef=useRef(null)

    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specified
    element. In this case, it is used to detect clicks outside of the dropdown component. When a click
    is detected outside of the dropdown component, the `setisOpen` function is called to set the
    `isOpen` state to `false`, effectively closing the dropdown. */
    useOnClickOutside(ref, () => {
        setisOpen(false);
    });

    /**
     * The function calculates the position of a dropdown menu based on the available space on the screen.
     */
    const calculateDropdownPosition = () => {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - buttonRect.bottom-40;
        //40px
        const dropdownHeight =dropdownRef.current.clientHeight;
    
        if (spaceBelow < dropdownHeight) {
            dropdownRef.current.style.top = `-${dropdownHeight}px`;
        } else {
            dropdownRef.current.style.top = '100%';
        }
    };

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, the
    `useEffect` hook is used to add an event listener for the `resize` event on the window object. When
    the `resize` event is triggered, the `calculateDropdownPosition` function is called to recalculate
    the position of the dropdown menu based on the available space on the screen. */
    useEffect(() => {
        window.addEventListener('resize', calculateDropdownPosition);
        calculateDropdownPosition(); // Initial position calculation
        return () => {
            window.removeEventListener('resize', calculateDropdownPosition);
        };
    }, [isOpen]);

    return (
        <div className={divClassName} data-te-dropdown-ref id={id} ref={ref}>
            <button
                ref={buttonRef}
                disabled={buttonDisabled !== undefined && buttonDisabled}
                title={title}
                onClick={() => setisOpen(!isOpen)}
                className={`sec_filter_btn`} //for AY dropdown in Promote History page
                type="button"
                id={dropDownName}
                data-testid = {test_id}
                data-te-dropdown-toggle-ref
                aria-expanded="false"
            >
                <p
                    className={`text-f7 ${
                        (value === "" || value === undefined || value === true)
                            ? "text-[#818E98]"
                            : "text-[#031624]"
                    } font-normal more-lines capitalize`}
                >
                    {(value === "" || value === undefined || value === true)
                        ? placeHolder
                        : value}
                </p>
                <img
                    src="/images/dropdown-icon.png"
                    alt="icon"
                    className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${
                        isOpen ? "transform rotate-180" : ""
                    }`}
                />
            </button>
            <ul
                ref={dropdownRef}
                className={`slct_drp_dwn min-w-full ${
                    isOpen ? "" : "hidden"
                } [&[data-te-dropdown-show]]:block`}
                aria-labelledby="dropdownMenu_acdemic_year"
                data-te-dropdown-menu-ref
                style={{'margin-left':'7px'}}
            >
                <li className="max-h-[161px] overflow-auto scroll-bar">
                    <ul>
                        {options?.length > 0 ? (
                            options.map((option, i) => (
                                <li
                                    key={i}
                                    id={i + 'AYname'}
                                    onClick={(e) => {
                                        handleOnchangeInput(dropDownName, option, index),
                                        setisOpen(false);
                                    }}
                                >
                                    <a
                                        title={option.title}
                                        className="slct_drp_dwn_optn"
                                    >
                                        {option.name}
                                    </a>
                                </li>
                            ))) : 
                            (
                                <li
                                    key=""
                                    id="select-option"
                                    onClick={(e) => {
                                        setisOpen(false);
                                    }}
                                >
                                    <a className="slct_drp_dwn_optn">
                                        - No options available -
                                    </a>
                                </li>
                            )
                        }
                    </ul>
                </li>
            </ul>
        </div>
    );
};

export default DropDownComponent;
